import type { RouteRecordRaw } from 'vue-router'

const goalRoutes: RouteRecordRaw[] = [
  {
    path: 'goals',
    component: () => import('@/views/goal/GoalLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/goals/okr'
      },
      {
        path: 'okr',
        name: 'okr-management',
        component: () => import('@/views/goal/OKRManagement.vue')
      },
      {
        path: 'weekly',
        name: 'weekly-goals',
        component: () => import('@/views/goal/WeeklyGoalManagement.vue')
      },
      {
        path: 'daily',
        name: 'daily-goals',
        component: () => import('@/views/goal/DailyGoalManagement.vue')
      },
      {
        path: 'review',
        name: 'okr-review',
        component: () => import('@/views/goal/OKRReviewList.vue')
      },
      {
        path: 'review/:id',
        name: 'okr-review-detail',
        component: () => import('@/views/goal/OKRReviewDetail.vue')
      },
      {
        path: 'dashboard',
        name: 'goal-dashboard',
        component: () => import('@/views/goal/GoalDashboard.vue')
      }
    ]
  }
]

export default goalRoutes
